import type { FC } from 'react'

import Pill from '@/components/Pill'
import { ReferenceOutcomeStatus } from '@/lib/apollo/model/outcome'
import { mapReferenceOutcomeStatus } from '@/utils/referenceOutcomeStatus'

interface Props {
  referenceOutcomeStatus: ReferenceOutcomeStatus
}

const ReferenceOutcomeStatusPill: FC<Props> = ({ referenceOutcomeStatus }) => {
  const statusText = mapReferenceOutcomeStatus(referenceOutcomeStatus)

  switch (referenceOutcomeStatus) {
    case ReferenceOutcomeStatus.pass:
      return <Pill type="positive">{statusText}</Pill>

    case ReferenceOutcomeStatus.fail:
    case ReferenceOutcomeStatus.awaitingReview:
      return <Pill type="caution">{statusText}</Pill>

    case ReferenceOutcomeStatus.expired:
    case ReferenceOutcomeStatus.pending:
      return <Pill type="info">{statusText}</Pill>

    default:
      return <Pill type="neutral">{statusText}</Pill>
  }
}

export default ReferenceOutcomeStatusPill
